import axios from 'axios'

const apiUrl = 'http://localhost:8080/customerList'

export const GET_CUSTOMER_LISTS = 'GET_CUSTOMER_LISTS'
export const GET_CUSTOMER_LIST = 'GET_CUSTOMER_LIST'
export const SET_CUSTOMER_LIST = 'SET_CUSTOMER_LIST'

export const getCustomerLists = (advertiserId) => {
  console.log(`fetching customer Lists`)
  const config = {
    params: {
      customer_list_created_advertiser_id: advertiserId
    }
  }
  return (dispatch) => {
    return axios.get(`${apiUrl}`, advertiserId ? config : null)
      .then(response => {
        dispatch({ type: GET_CUSTOMER_LISTS, customerLists: response.data })
      })
      .catch(error => {
        console.log(`error getting customer lists: ${error}`)
      })
  }
}

export const getCustomerList = (paramKey, paramVal) => {
  const config = {
    params: {
      [paramKey]: paramVal
    }
  }
  return (dispatch) => {
    return axios.get(`${apiUrl}`, config)
      .then(response => {
        dispatch({ type: GET_CUSTOMER_LIST, customerList: response.data[0] })
      })
      .catch(error => {
        console.log(`error getting customer list: ${error}`)
      })
  }
}

export const setCustomerList = (customerList) => ({ type: SET_CUSTOMER_LIST, customerList: customerList })